/** @jsx jsx */
import { Alert, Button, Intent, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { css, jsx } from '@emotion/core';
import { Fragment, useState } from 'react';
import AppToaster from '../../../AppToaster';
import { TagDetailPageFragment, useDeleteTagMutation } from '../../../generated/graphql';

type TagDetailMenuProps = {
  tag: TagDetailPageFragment;
  onEdit: () => void;
};

const TagDetailMenu = ({ tag, onEdit }: TagDetailMenuProps) => {
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
  const [deleteTag, { loading: deleting }] = useDeleteTagMutation({
    variables: {
      id: tag.id,
    },
    onCompleted: () => AppToaster.success(`${tag.name} wurde entfernt`),
  });

  return (
    <Fragment>
      <Alert
        isOpen={isDeleteAlertOpen}
        cancelButtonText="Abbrechen"
        confirmButtonText="Entfernen"
        icon={IconNames.DELETE}
        intent={Intent.DANGER}
        onClose={() => setIsDeleteAlertOpen(false)}
        onConfirm={deleteTag as any}
      >
        <p>Soll dieses Attribut wirklich undwiderruflich entfernt werden?</p>
      </Alert>
      <Button text="Bearbeiten" icon={IconNames.EDIT} css={styles.headerButton} onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem
              text="Entfernen"
              icon={IconNames.DELETE}
              intent={Intent.DANGER}
              onClick={() => setIsDeleteAlertOpen(true)}
            />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} css={styles.headerButton} loading={deleting} />
      </Popover>
    </Fragment>
  );
};

export default TagDetailMenu;

const styles = {
  statusTag: css`
    margin-left: 10px;
  `,
  headerButton: css`
    margin-left: 10px;
  `,
};
